export default __webpack_public_path__ + "static/media/phone.9dd80e71.png";